import { cn } from '@change/ds-utils';

import { Text } from '@change/ds-core-ui/next';

type Props = {
	title: string;
	className?: string;
};

export function MainContentTitle({ title, className }: Props) {
	return (
		<div className={cn('px-4 pb-0 pt-8 md:px-12 md:pt-12', className)}>
			<Text as="h2" className="text-size-heading-small md:text-size-heading">
				{title}
			</Text>
		</div>
	);
}
